/**
 * Transform function for getArticle method
 * Handles flattening of blogs and articles from the optimized query
 * Receives validated blogs data from service layer
 */
export function mapGetArticleToResponse(blogs: any) {
  const blogsNodes = blogs?.nodes ?? [];

  // Flatten all articles from all blogs
  return blogsNodes.flatMap((blog: any) => blog.articles?.nodes || []);
}

/**
 * Transform function for getBlogArticles method
 * Handles blog-specific article listing with pagination
 * Receives validated blog data from service layer
 */
export function mapGetBlogArticlesToResponse(blog: any) {
  const articles = blog.articles?.nodes || [];

  return {
    articles,
    totalCount: articles.length,
    blog: {
      title: blog.title,
      seo: blog.seo,
    },
  };
}

/**
 * Transform function for getTrendingArticles method
 * Handles trending articles from a specific blog
 * Receives validated blog data from service layer
 */
export function mapGetTrendingArticlesToResponse(blog: any) {
  return blog.articles?.nodes || [];
}

/**
 * Transform function for getArticleByHandle method
 * Handles single article retrieval
 * Receives validated article data from service layer
 */
export function mapGetArticleByHandleToResponse(article: any) {
  return article;
}
